export const usersTypes = {
    GET_USERS: "GET_USERS",
};
